import { CreatorIntegrationsApiClient } from '@fourthwall/services/dist/CreatorIntegrationsApiClient'
import { createMutationHook } from '@fourthwall/utils/dist/queries'

export const useUpdateBeehiivConfigurationMutation = createMutationHook(
  CreatorIntegrationsApiClient.updateBeehiivConfiguration,
  {
    mutationKey: ['updateBeehiivConfiguration'],
  },
)
